'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _enhancers = require('./enhancers');

var _enhanceProps3 = require('./enhance-props');

var _enhanceProps4 = _interopRequireDefault(_enhanceProps3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var cssWarned = false;

var Box = function (_React$Component) {
  _inherits(Box, _React$Component);

  function Box() {
    _classCallCheck(this, Box);

    return _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).apply(this, arguments));
  }

  _createClass(Box, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          is = _props.is,
          css = _props.css,
          innerRef = _props.innerRef,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['is', 'css', 'innerRef', 'children']); // Convert the CSS props to class names (and inject the styles)


      var _enhanceProps = (0, _enhanceProps4.default)(props),
          _enhanceProps2 = _slicedToArray(_enhanceProps, 2),
          className = _enhanceProps2[0],
          parsedProps = _enhanceProps2[1]; // Add glamor class


      if (css) {
        // Warn that it's deprecated in the development
        if (process.env.NODE_ENV !== 'production') {
          // Don't spam the warning
          if (!cssWarned) {
            cssWarned = true;
            console.warn("\uD83D\uDCE6 ui-box deprecation: the \u201Ccss\u201D prop will be removed in the next major version in favour of importing glamor directly and passing it\u055As generated class to the \u201CclassName\u201D prop.");
          }
        }

        parsedProps.className = className + ' ' + (0, _glamor.css)(css).toString();
      } else {
        parsedProps.className = className;
      }

      if (innerRef) {
        parsedProps.ref = function (node) {
          innerRef(node);
        };
      }

      return _react2.default.createElement(is, parsedProps, children);
    }
  }]);

  return Box;
}(_react2.default.Component);

Box.displayName = 'Box';
Box.propTypes = _extends({}, _enhancers.propTypes, {
  css: _propTypes2.default.object,
  innerRef: _propTypes2.default.func,
  is: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  boxSizing: _enhancers.propTypes.boxSizing
});
Box.defaultProps = {
  css: null,
  innerRef: null,
  is: 'div',
  boxSizing: 'border-box'
};
exports.default = Box;